import React, { createContext, useContext, useEffect } from 'react';
import logger from '@/lib/logger';

const ThemeContext = createContext();

export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
};

/**
 * Theme is locked to Patriot dark identity — single source of truth.
 * Light mode was intentionally eliminated per brand decision.
 * Toggle is a no-op (kept for component API stability).
 */
export const ThemeProvider = ({ children }) => {
  useEffect(() => {
    document.documentElement.classList.add('dark');
    document.documentElement.style.colorScheme = 'dark';
    // Purge any stale light-mode preference
    try {
      localStorage.removeItem('theme');
    } catch (err) {
      // ignore storage errors (private mode / quota)
      logger.debug('ThemeContext: could not remove stale theme preference', err);
    }
  }, []);

  const value = {
    theme: 'dark',
    isDark: true,
    toggleTheme: () => {},
    setTheme: () => {},
  };

  return (
    <ThemeContext.Provider value={value}>
      {children}
    </ThemeContext.Provider>
  );
};
